import { useCallback } from "react";

export const useCloseOnEscape = ({
  enabled,
  onClose,
}: {
  enabled: boolean;
  onClose: () => void;
}): ((event: React.KeyboardEvent<HTMLDivElement>) => void) =>
  useCallback(
    (event: React.KeyboardEvent<HTMLDivElement>) => {
      if (!enabled || event.key !== "Escape") return;
      event.preventDefault();
      event.stopPropagation();
      onClose();
    },
    [enabled, onClose]
  );
